// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.video-analysis-settings-dialog__subtitle {
  display: block;
  margin-top: 4px;
  font-size: 13px;
  font-weight: 500;
  opacity: 0.75;
  line-height: 1.35;
}

.video-analysis-settings-dialog__field {
  display: flex;
  flex-direction: column;
  gap: 6px;
  margin-top: 4px;
}

.video-analysis-settings-dialog__field + .video-analysis-settings-dialog__field {
  margin-top: 20px;
}

.video-analysis-settings-dialog__fieldset {
  border: 0;
  margin: 20px 0 0;
  padding: 0;
  min-inline-size: 0;
}

.video-analysis-settings-dialog__fieldset > legend {
  padding: 0;
  float: left;
  width: 100%;
}

.video-analysis-settings-dialog__fieldset > legend + * {
  clear: both;
}

.video-analysis-settings-dialog__segment {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 6px;
  margin-top: 8px;
}

.video-analysis-settings-dialog__segment-btn {
  appearance: none;
  border: 1px solid rgba(128, 128, 128, 0.35);
  background: rgba(128, 128, 128, 0.08);
  color: inherit;
  border-radius: 10px;
  padding: 10px 8px;
  font-size: 13px;
  font-weight: 650;
  line-height: 1.25;
  cursor: pointer;
  transition:
    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),
    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1);
}

.video-analysis-settings-dialog__segment-btn:hover {
  background: rgba(128, 128, 128, 0.14);
}

.video-analysis-settings-dialog__segment-btn:active {
  transform: scale(0.97);
}

.video-analysis-settings-dialog__segment-btn.is-selected {
  border-color: rgba(10, 132, 255, 0.55);
  background: rgba(10, 132, 255, 0.16);
  box-shadow: inset 0 0 0 1px rgba(10, 132, 255, 0.25);
}

.video-analysis-settings-dialog__segment-btn:focus-visible {
  outline: 2px solid rgba(10, 132, 255, 0.55);
  outline-offset: 2px;
}

.video-analysis-settings-dialog__label {
  font-size: 14px;
  font-weight: 650;
}

.video-analysis-settings-dialog__hint {
  font-size: 12.5px;
  line-height: 1.4;
  opacity: 0.78;
}

.video-analysis-settings-dialog__fps-row {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-top: 4px;
}

.video-analysis-settings-dialog__select {
  appearance: none;
  width: 100%;
  max-width: 160px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px solid rgba(128, 128, 128, 0.35);
  background: rgba(128, 128, 128, 0.08);
  color: inherit;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
}

.video-analysis-settings-dialog__select:focus-visible {
  outline: 2px solid rgba(10, 132, 255, 0.55);
  outline-offset: 2px;
}

.video-analysis-settings-dialog__range {
  width: 100%;
  accent-color: #0a84ff;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/components/VideoAnalysisSettingsDialog.css"],"names":[],"mappings":"AAAA;EACE,cAAc;EACd,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,gBAAgB;EAChB,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,gDAAgD;EAChD,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,mBAAmB;EACnB,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf;;;iDAG+C;AACjD;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,sCAAsC;EACtC,oCAAoC;EACpC,oDAAoD;AACtD;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,2CAA2C;EAC3C,qCAAqC;EACrC,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,2CAA2C;EAC3C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,qBAAqB;EACrB,eAAe;AACjB","sourcesContent":[".video-analysis-settings-dialog__subtitle {\n  display: block;\n  margin-top: 4px;\n  font-size: 13px;\n  font-weight: 500;\n  opacity: 0.75;\n  line-height: 1.35;\n}\n\n.video-analysis-settings-dialog__field {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  margin-top: 4px;\n}\n\n.video-analysis-settings-dialog__field + .video-analysis-settings-dialog__field {\n  margin-top: 20px;\n}\n\n.video-analysis-settings-dialog__fieldset {\n  border: 0;\n  margin: 20px 0 0;\n  padding: 0;\n  min-inline-size: 0;\n}\n\n.video-analysis-settings-dialog__fieldset > legend {\n  padding: 0;\n  float: left;\n  width: 100%;\n}\n\n.video-analysis-settings-dialog__fieldset > legend + * {\n  clear: both;\n}\n\n.video-analysis-settings-dialog__segment {\n  display: grid;\n  grid-template-columns: repeat(3, minmax(0, 1fr));\n  gap: 6px;\n  margin-top: 8px;\n}\n\n.video-analysis-settings-dialog__segment-btn {\n  appearance: none;\n  border: 1px solid rgba(128, 128, 128, 0.35);\n  background: rgba(128, 128, 128, 0.08);\n  color: inherit;\n  border-radius: 10px;\n  padding: 10px 8px;\n  font-size: 13px;\n  font-weight: 650;\n  line-height: 1.25;\n  cursor: pointer;\n  transition:\n    background 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    border-color 0.2s cubic-bezier(0.25, 1, 0.5, 1),\n    transform 0.15s cubic-bezier(0.25, 1, 0.5, 1);\n}\n\n.video-analysis-settings-dialog__segment-btn:hover {\n  background: rgba(128, 128, 128, 0.14);\n}\n\n.video-analysis-settings-dialog__segment-btn:active {\n  transform: scale(0.97);\n}\n\n.video-analysis-settings-dialog__segment-btn.is-selected {\n  border-color: rgba(10, 132, 255, 0.55);\n  background: rgba(10, 132, 255, 0.16);\n  box-shadow: inset 0 0 0 1px rgba(10, 132, 255, 0.25);\n}\n\n.video-analysis-settings-dialog__segment-btn:focus-visible {\n  outline: 2px solid rgba(10, 132, 255, 0.55);\n  outline-offset: 2px;\n}\n\n.video-analysis-settings-dialog__label {\n  font-size: 14px;\n  font-weight: 650;\n}\n\n.video-analysis-settings-dialog__hint {\n  font-size: 12.5px;\n  line-height: 1.4;\n  opacity: 0.78;\n}\n\n.video-analysis-settings-dialog__fps-row {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-top: 4px;\n}\n\n.video-analysis-settings-dialog__select {\n  appearance: none;\n  width: 100%;\n  max-width: 160px;\n  padding: 10px 12px;\n  border-radius: 10px;\n  border: 1px solid rgba(128, 128, 128, 0.35);\n  background: rgba(128, 128, 128, 0.08);\n  color: inherit;\n  font-size: 14px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.video-analysis-settings-dialog__select:focus-visible {\n  outline: 2px solid rgba(10, 132, 255, 0.55);\n  outline-offset: 2px;\n}\n\n.video-analysis-settings-dialog__range {\n  width: 100%;\n  accent-color: #0a84ff;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
